import { connect } from "react-redux";
import { UPDATE_PERSONA } from "./query";
import { setPersonaGroupList, getPersonaGroupList } from "../../reducers";
import Form from "./form";

const EditPersonaGroup = (props: any) => {
    const { title, personaGroup } = props;

    const editPersonaGroupData = {
        id: personaGroup.id,
        personaName: personaGroup.personaName,
        appName: personaGroup.appName,
        country: personaGroup.country,
        mailAddress: personaGroup.email,
    };

    return (
        <div className="cmp-edit">
            <h5 className="cmp-edit__title">{title}</h5>
            <Form formType="update" formData={editPersonaGroupData} query={UPDATE_PERSONA} />
        </div>
    );
};

const mapStateToProps = (state: any) => {
    return {
        personaGroupList: getPersonaGroupList(state),
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        setPersonaList: (personaList: any) => {
            dispatch(setPersonaGroupList(personaList));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPersonaGroup);
